import styled from 'styled-components';
import * as colors from '../../../../../../components/common/colorConstants';
import { TextInput } from 'components/common/formElements';

export const CustomerDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const CustomerDetailsLabel = styled.label`
  font-size: 12px;
  color: ${colors.lightBlack};
  font-weight: 400;
  margin-bottom: 0;
`;

export const CustomerDetailsInputWrapper = styled.div`
  position: relative;
`;

export const CustomerDetailsInputField = styled(TextInput)`
  width: 180px;
  font-size: 12px;
  line-height: 17px;
  padding: 4px;
  font-weight: 500;
`;
